import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const heroImg = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/w71seqwk_WhatsApp%20Image%202026-08-21%20at%2018.43.52.jpeg";
const poolImg = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/ine6jqxk_WhatsApp%20Image%202026-08-21%20at%2018.43.51.jpeg";
const foodImg = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/36sqbz4m_WhatsApp%20Image%202026-08-21%20at%2018.43.51%20%281%29.jpeg";
const roomImg = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/q3fuu3dh_WhatsApp%20Image%202026-08-21%20at%2018.43.51%20%282%29.webp";

export default function CorteMiniera() {
  return (
    <Layout>
      {/* HERO */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-6">
          <div className="overline">La Corte della Miniera</div>
          <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mt-3">
            Dove la storia<br/>diventa <em className="text-[#8C3A27] not-italic">ospitalità</em>.
          </h1>
          <p className="mt-6 text-lg text-[#6B6960] leading-relaxed max-w-lg">
            La Corte della Miniera è il sistema operativo di Museum Graphia: alloggio, cucina,
            logistica e servizi che accolgono scuole, gruppi e viaggiatori a pochi minuti da Urbino,
            nelle colline delle Marche.
          </p>
        </div>
        <div className="lg:col-span-6 aspect-[4/3] overflow-hidden">
          <img src={heroImg} alt="Panorama Corte della Miniera al mattino" className="w-full h-full object-cover" />
        </div>
      </section>

      {/* STORIA: DALLA MINIERA ALL'OSPITALITÀ */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 border-t border-[#E2DFD6] grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="overline">Storia · Riconversione</div>
          <h2 className="font-display text-4xl lg:text-5xl mt-3">Dalle miniere all'ospitalità.</h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 text-[#6B6960] leading-relaxed space-y-3">
          <p>
            A pochi chilometri da Urbino sorgeva un'antica miniera di zolfo, attiva per circa un
            secolo, che dava lavoro a centinaia di persone. Dagli anni Novanta il complesso è stato
            recuperato con un importante intervento di riconversione: gli antichi forni di fusione
            sono diventati laboratori artistici, gli edifici della miniera sono oggi parte della
            struttura ricettiva.
          </p>
          <p>
            La filosofia della Corte della Miniera è semplice: <strong>non cancellare il passato,
            ma trasformarlo in esperienza</strong>. Si dorme dove un tempo lavoravano i minatori,
            si mangia insieme, si cammina nella natura, si fa esperienza attraverso i laboratori.
          </p>
        </div>
      </section>

      {/* SERVIZI OSPITALITÀ - 3 CARDS */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="overline">Il sistema operativo del museo</div>
        <h2 className="font-display text-4xl lg:text-5xl mt-3 max-w-3xl">Alloggio, cucina, logistica, servizi.</h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="border border-[#E2DFD6] bg-white overflow-hidden hover-lift">
            <div className="aspect-[4/3] overflow-hidden"><img src={roomImg} alt="Camera" className="w-full h-full object-cover" /></div>
            <div className="p-6">
              <div className="overline">Alloggio</div>
              <h3 className="font-display text-2xl mt-2">Camere per gruppi & famiglie</h3>
              <p className="mt-2 text-sm text-[#6B6960] leading-relaxed">
                Camere multiple e doppie, pensate per l'accoglienza di scuole, delegazioni e famiglie.
                Dormire negli spazi dell'antica miniera, restaurati e vissuti.
              </p>
            </div>
          </div>
          <div className="border border-[#E2DFD6] bg-white overflow-hidden hover-lift">
            <div className="aspect-[4/3] overflow-hidden"><img src={foodImg} alt="Ristorazione" className="w-full h-full object-cover" /></div>
            <div className="p-6">
              <div className="overline">Cucina</div>
              <h3 className="font-display text-2xl mt-2">Il cibo come parte del viaggio</h3>
              <p className="mt-2 text-sm text-[#6B6960] leading-relaxed">
                La tavola diventa il luogo nel quale incontrare il territorio: prodotti, ricette
                e sapori della tradizione marchigiana in un ambiente informale e conviviale.
              </p>
            </div>
          </div>
          <div className="border border-[#E2DFD6] bg-white overflow-hidden hover-lift">
            <div className="aspect-[4/3] overflow-hidden"><img src={poolImg} alt="Piscina e paesaggio" className="w-full h-full object-cover" /></div>
            <div className="p-6">
              <div className="overline">Servizi & Natura</div>
              <h3 className="font-display text-2xl mt-2">Piscina, spazi comuni, paesaggio</h3>
              <p className="mt-2 text-sm text-[#6B6960] leading-relaxed">
                Aree verdi, piscina e spazi all'aperto per vivere le colline marchigiane
                fra un laboratorio e una visita a Urbino, Gradara o San Marino.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AGRITURISMO, MA NON SOLO */}
      <section className="bg-[#2A312B] text-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline text-[#D7B565]">Un agriturismo, ma non solo</div>
            <h2 className="font-display text-4xl lg:text-5xl mt-3">Una vacanza diversa,<br/>un territorio da vivere.</h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-[#F9F8F6]/85 leading-relaxed space-y-3">
            <p>
              Pensata per famiglie, gruppi, viaggiatori, scuole e persone interessate a conoscere un
              territorio attraverso le sue storie e le sue tradizioni. L'esperienza comprende
              ospitalità, cucina, natura, cultura e attività laboratoriali, in un ambiente nel quale
              gli spazi stessi raccontano la storia del luogo.
            </p>
            <p>
              La vicinanza a Urbino — Patrimonio Mondiale UNESCO dal 1998 — rende La Corte della
              Miniera un punto di partenza privilegiato per scoprire una delle città più importanti
              del Rinascimento italiano, senza rinunciare al paesaggio di colline, boschi e campagne
              del Montefeltro.
            </p>
          </div>
        </div>
      </section>

      {/* MUSEUM GRAPHIA INTEGRATION */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="overline">Museum Graphia dentro la Corte</div>
          <h2 className="font-display text-4xl lg:text-5xl mt-3">Si tocca. Si sperimenta. Si produce.</h2>
          <p className="mt-6 text-[#6B6960] leading-relaxed">
            Uno degli elementi che rendono La Corte della Miniera originale è la presenza di
            <strong> Museum Graphia — Museo Internazionale del Segno</strong>, ospitato all'interno
            del complesso dell'antica miniera. La cultura, qui, non viene soltanto osservata: viene
            I laboratori di stampa e arti applicate permettono di imparare attraverso il fare,
          </p>
          <div className="mt-8 flex gap-3">
            <Link to="/museum-graphia"><Button variant="outline" className="rounded-full h-11 px-6 border-[#1A1A1A]/20">Scopri Museum Graphia</Button></Link>
            <Link to="/servizi"><Button className="btn-primary-cdm rounded-full h-11 px-6">Vedi i laboratori</Button></Link>
          </div>
        </div>
        <div className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-3 text-sm">
            {[
              { t: "Alloggio", d: "Camere multiple e doppie negli spazi restaurati della miniera" },
              { t: "Ristorazione", d: "Cucina marchigiana con prodotti del territorio" },
              { t: "Logistica gruppi", d: "Programmi integrati soggiorno + laboratori + visite" },
              { t: "Natura", d: "Colline, boschi, piscina e spazi all'aperto" },
              { t: "Cultura", d: "Museum Graphia e laboratori attivi dentro la struttura" },
              { t: "Formazione", d: "PCTO, Erasmus+ VET, Adult Education, Job Shadowing" },
            ].map((c) => (
              <div key={c.t} className="border border-[#E2DFD6] p-4 bg-white">
                <div className="overline">{c.t}</div>
                <div className="mt-1 text-[#1A1A1A] leading-snug">{c.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* UN LUOGO PER IMPARARE */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 border-t border-[#E2DFD6] grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="overline">Un luogo per imparare</div>
          <h2 className="font-display text-4xl mt-3">Non una gita.<br/>Un'esperienza di vita.</h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 text-[#6B6960] leading-relaxed">
          Da molti anni La Corte della Miniera accoglie gruppi scolastici e propone programmi nei quali
          soggiorno, territorio e attività didattiche vengono integrati. Gli studenti alternano la
          scoperta di Urbino e del Montefeltro alle attività nei laboratori artistici, alla vita
          all'aria aperta e alla conoscenza della storia industriale del luogo.
        </div>
      </section>

      {/* MANIFESTO / CTA */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <div className="bg-[#8C3A27] text-[#F9F8F6] px-10 py-16">
          <div className="overline text-[#D7B565]">Una miniera che ha cambiato vita</div>
          <h3 className="font-display text-4xl lg:text-5xl mt-3 max-w-3xl">
            La Corte della Miniera non è solo un posto dove dormire.
          </h3>
          <p className="mt-4 text-[#F9F8F6]/85 max-w-2xl">
            È un posto dove fermarsi, conoscere, mangiare, imparare e respirare una storia che continua.
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl">
            <div className="border border-[#F9F8F6]/20 px-5 py-4"><div className="font-display text-2xl">Vieni a scoprire la Miniera</div></div>
            <div className="border border-[#F9F8F6]/20 px-5 py-4"><div className="font-display text-2xl">Vieni a scoprire Urbino</div></div>
            <div className="border border-[#F9F8F6]/20 px-5 py-4"><div className="font-display text-2xl">Vieni a vivere le Marche</div></div>
          </div>
          <div className="mt-10 flex gap-3">
            <Link to="/prenota"><Button className="bg-[#F9F8F6] text-[#1A1A1A] hover:bg-white rounded-full h-12 px-7">Prenota il tuo soggiorno</Button></Link>
            <Link to="/contatti"><Button variant="outline" className="rounded-full h-12 px-7 border-[#F9F8F6]/40 text-[#F9F8F6] hover:bg-[#F9F8F6]/10">Scrivici</Button></Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
